import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { Auth } from "aws-amplify";
import { useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Swal from "sweetalert2";
import { deleteUserFolder } from "../../utils/deleteUserFolder";
import { uploadFileViaPresignedUrl } from "../../utils/uploadFileViaPresignedUrl";

export default function FinanceSummarization({ title, link }) {
  const [file, setFile] = useState(null);
  const [trainload, setTrainload] = useState(false);
  const [compareLoad, setCompareLoad] = useState(false);
  const [pdfLoad, setPdfLoad] = useState(false);
  const [error, setError] = useState("");
  const [error1, setError1] = useState("");
  const [userquery, setUserQuery] = useState("");
  const [uploadStatus, setUploadStatus] = useState(false);
  const [transcript, setTranScript] = useState("");
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    if (transcript && transcript.length > 0) {
      // console.log("Original Transcript: ", transcript);
      const formattedTranscript = formatResponse(transcript);
      // console.log("Formatted Response: ", formattedTranscript);
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + formattedTranscript[index]);
        index++;
        if (index === formattedTranscript.length) {
          clearInterval(intervalId);
          setTranScript("");
        }
      }, 1);
    }
  }, [transcript]);

  const formatResponse = (response) => {
    // Replacing markdown-like headers with HTML headers
    const headers = response
      .replace(/(######\s?)(.*?)\n/g, "<h6>$2</h6>")
      .replace(/(#####\s?)(.*?)\n/g, "<h5>$2</h5>")
      .replace(/(####\s?)(.*?)\n/g, "<h4>$2</h4>")
      .replace(/(###\s?)(.*?)\n/g, "<h3>$2</h3>")
      .replace(/(##\s?)(.*?)\n/g, "<h2>$2</h2>")
      .replace(/(#\s?)(.*?)\n/g, "<h1>$2</h1>");

    // Splitting and replacing bold markers
    let responseArray = headers.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    // Replace asterisks and newlines for proper HTML formatting
    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const getUsername = () =>
    localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );

  const handleUpload = async () => {
    setPdfLoad(true);

    try {
      const username = getUsername();
      await deleteUserFolder(username);
      await uploadFileViaPresignedUrl(file, username);
      console.log("File uploaded successfully");
      setUploadStatus(true);
      setPdfLoad(false);
      setError("File 1 uploaded successfully.");
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
    }
  };

  const handleTrain = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    if (file) {
      setError("");
      setTrainload(true);
      console.log("training started");
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        docname: file.name,
      });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      // Create the fetch requests
      const requesttrain = fetch(
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/rag-universal-chatbot-training",
        trainoption,
      );

      Promise.all([requesttrain])
        .then(async ([trainresponse]) => {
          if (!trainresponse.ok) {
            setError("Training Failed!");
            setTrainload(false);
            throw new Error("One or both requests failed");
          }
          const data = await trainresponse.json();

          console.log("Response from endpoint 1:", data);
          if (trainresponse.ok) {
            setError("Training completed.");
            setTrainload(false);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setError("Training Failed!");
          setTrainload(false);
        });
    } else {
      Swal.fire({
        html: "<p>Please upload the CSV file</p>",
      });
    }
  };

  const handleCompare = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    setDisplayText("");
    try {
      setCompareLoad(true); // Start the loading state
      // Add filename passing parameter in POST request and run POST request of chatbot
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        userPrompt: userquery,
      });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      // Create the fetch request
      const requesttrain = await fetch(
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/finance-document-summarization-response-cot", // Replace with your actual AWS API endpoint
        trainoption,
      );

      // Check if the response is successful
      if (!requesttrain.ok) {
        console.error(`HTTP error! status: ${requesttrain.status}`);
        return;
      }

      let response;
      try {
        response = await requesttrain.json();
      } catch (jsonError) {
        console.error("Error parsing JSON:", jsonError);
        return;
      }

      // Inspect the full response
      console.log("Full response:", response);

      setTranScript(response.messsage);
      // Log the data
      console.log("Response data:", response.messsage);
    } catch (error) {
      // Handle any errors
      console.error("There was an error with the fetch request:", error);
    } finally {
      setCompareLoad(false); // End the loading state
    }
  };

  const handleButtonClick = () => {
    if (file) {
      handleTrain();
    } else {
      setError("Please upload pdf file");
    }
  };

  const handleGenerateAnswer = () => {
    if (!userquery) {
      setError1("Please enter your query");
      return; // Exit the function if userquery is empty
    }

    if (!file) {
      setError1("Please upload both files");
      return; // Exit the function if both files are not uploaded
    }
    setError1("");
    handleCompare();
  };

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          alt="overlay-img"
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          alt="main-background-img"
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      {genaiaccess ? (
        <div
          style={{
            flex: "0.3",
            marginBottom: "1rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            width: "80vw",
            gap: "3rem",
            margin: "auto",
          }}
          className="input-form-chatbot"
        >
          <div className="section-container">
            <h4>
              <strong>Finance File upload window</strong>
            </h4>
            <hr style={{ background: "white" }}></hr>
            <div>
              <p>Upload a PDF file containing data:</p>
              <div className="field">
                <div>
                  <input
                    accept=".pdf"
                    id="pdf-upload"
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="pdf-upload">
                    <Button
                      variant="contained"
                      component="span"
                      style={{ width: "130px", marginRight: "1rem" }}
                      startIcon={
                        pdfLoad && <CircularProgress color="white" size={20} />
                      }
                    >
                      Select PDF
                    </Button>
                  </label>

                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    disabled={!file}
                    onClick={handleUpload}
                  >
                    Upload PDF
                  </Button>
                  {uploadStatus && (
                    <FaCheckCircle
                      style={{
                        marginLeft: "1rem",
                        color: "green",
                        transform: "translateY(10px)",
                      }}
                      size={25}
                    />
                  )}
                </div>
                <Typography variant="body1">
                  <p style={{ wordBreak: "break-all", width: "350px" }}>
                    {file && `Selected file: ${file.name}`}
                  </p>
                </Typography>
              </div>

              <div style={{ display: "flex" }}>
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  style={{ color: "white" }}
                  onClick={handleButtonClick}
                  startIcon={
                    trainload && <CircularProgress color="white" size={20} />
                  }
                >
                  Train
                </Button>
              </div>
              <p>{error}</p>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
      <div
        className="input-form-chatbot"
        style={{
          flex: "0.3",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          width: "80vw",
          margin: "2rem auto",
        }}
      >
        <div className="section-container">
          <p>Enter a question based on the PDF files:</p>
          <TextareaAutosize
            id="outlined-basic"
            minRows={1}
            value={userquery}
            onChange={(e) => setUserQuery(e.target.value)}
            style={{
              border: "1px solid white",
              borderRadius: "0.5rem",
              width: "100%",
              color: "white",
              backgroundColor: "transparent",
              padding: "16.5px 14px", // Adjusted padding to match TextField height
              fontSize: "16px", // Same font size as TextField
              lineHeight: "1.4375em", // Match the line height of MUI TextField
              resize: "none", // Disable manual resizing
              overflow: "hidden", // Hide scrollbar
              boxSizing: "border-box", // Ensure padding and border are included in the element's width and height
            }}
          />
          <Button
            style={{ margin: "1rem 0" }}
            variant="contained"
            color="primary"
            onClick={handleGenerateAnswer}
            startIcon={
              compareLoad && <CircularProgress color="white" size={20} />
            }
          >
            Generate Answer
          </Button>
          <p>{error1}</p>
        </div>
        <br />
        <br />
        <div className="section-container">
          <h4>
            <strong>Generated Response</strong>
          </h4>
          <hr style={{ background: "white" }}></hr>
          {displayText.length > 0 ? (
            <div
              style={{
                color: "white",
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
              }}
              dangerouslySetInnerHTML={{ __html: displayText }}
            ></div>
          ) : (
            "Response will be displayed here"
          )}
        </div>
      </div>
    </div>
  );
}
